export function deleteField(field) {
    field.parentCollection.deleteField(field);
    field.screen.setActive(null);
}

export function toggleExpanded(collection) {
    collection.toggleExpanded();
}

export function moveToVisibleEnd(field) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }
    const group = screen.selectedGroupSorted;
    if (group && group.length > 0) {
        group.forEach(f => {
            f.parentCollection.moveField(f, f.parentCollection.firstHiddenIdx - 1);
        });
        group[0].setMovedDown(true);
    } else {
        field.parentCollection.moveField(field, field.parentCollection.firstHiddenIdx - 1);
        field.setMovedDown(true);
    }
}

export function moveToEnd(field) {
    field.parentCollection.moveField(field, field.parentCollection.fields.length - 1);
    field.setMoved(true);
}

export function moveDown(field) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }
    const group = screen.selectedGroupSorted;
    if (group.length > 0) {
        let newIdx;
        for (let i = group.length - 1; i >= 0; i--) {
            const f = group[i];
            if (i === group.length - 1) {
                newIdx = f.index + 1;
            } else {
                newIdx--;
            }
            f.parentCollection.moveField(f, newIdx);
        }
    } else {
        field.parentCollection.moveField(field, field.index + 1);
        field.setMovedDown(true);
    }
}

export function isMoveDownDisabled(field) {
    const {screen} = field;
    const {selectedGroupSorted} = screen;

    //field.parentField.isDesign logic taken from getisMovable in the GWT that get execute in ReportDesigner.java:880
    return (
        !field.nextField ||
        field.nextField.hidden ||
        field.parentField.isDesign ||
        (selectedGroupSorted.length > 0 &&
            (!selectedGroupSorted[selectedGroupSorted.length - 1].nextField ||
                selectedGroupSorted[selectedGroupSorted.length - 1].nextField.hidden))
    );
}

export function moveToTop(field) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }
    const group = screen.selectedGroupSorted;
    if (group.length > 0) {
        let count = 0;
        group.forEach(f => {
            f.parentCollection.moveField(f, count++);
        });
        group[0].setMoved(true);
    } else {
        field.parentCollection.moveField(field, field.parentCollection.firstAvailableIdx);
        field.setMoved(true);
    }
}

export function moveUp(field) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }
    const group = screen.selectedGroupSorted;

    if (group.length > 0) {
        let newIdx;
        group.forEach((field, index) => {
            if (index === 0) {
                newIdx = field.index - 1;
            } else {
                newIdx++;
            }
            field.parentCollection.moveField(field, newIdx);
        });
        group[0].setMovedUp(true);
    } else {
        field.parentCollection.moveField(field, field.index - 1);
        field.setMovedUp(true);
    }
}

export function isMoveUpDisabled(field) {
    const {screen} = field;
    const {selectedGroupSorted} = screen;
    return (
        field.index === field.parentCollection.firstAvailableIdx ||
        field.parentField.isDesign ||
        (selectedGroupSorted.length > 0 &&
            selectedGroupSorted[0].idx === field.parentCollection.firstAvailableIdx)
    );
}
